import { GetUserInfoResponseType } from '../../types/user.types'
import { USER_INFO_QUERY } from '../../gql/queries/user'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import useSWR, { SWRResponse } from 'swr'

export const useGetUserInfo = (): SWRResponse<GetUserInfoResponseType, Error> => {
  const { isAuthenticated } = useAuthState()
  const userInfoData = useSWR<GetUserInfoResponseType>(
    () => (isAuthenticated ? USER_INFO_QUERY : null),
    {
      revalidateOnFocus: false
    }
  )

  return userInfoData
}
